
module.config(function($stateProvider) {

    $stateProvider.state('settings.users', {
        abstract: true,
        url: '/users',
        permission: 'viewUsers',
        templateUrl: 'empty',
    });

    $stateProvider.state('settings.users.index', {
        templateUrl: 'settings/users',
        url: '',
        controller: module.cC({
            inject: ['$scope', '$http', 'QueryStringFilter', 'ApiUrl', 'momentConvertFilter'],

            data: {
                loaded: 'false',
                users: '[]',
                url: 'ApiUrl("person")',
                pills: '[{name: "All", value: "all"}, {name: "Coaches", value: "coaches"},'+
                    '{name: "Program Staff", value: "program"}, {name:"YBGlobal Staff", value: "ybusa"}]',
                filter: 'QueryStringFilter({query:"", page:1, sort:"last", ' +
                    'direction:"asc", type:"all"})',
                staffTypes: "[['staff', 'Staff of'], ['consultant', 'Consults for']," +
                    "['program_staff', 'Program staff of'], ['coach', 'Coaches']]",
            },

            watch: {
                "{object}filter.params()": '_paramChange',
            },

            methods: {
                _paramChange: function(params, oldParams) {
                    if (params) {
                        if (oldParams && params.page === oldParams.page && params.page !== 1) {
                            this.filter.page = 1;
                        } else {
                            this._getUsers(params);
                        }
                    }
                },

                _getUsers: function(params) {
                    var momentConvertFilter = this.momentConvertFilter;
                    this.$http.get(this.url, {params: params})
                        .then(function(response) {
                            response.data.items.pager = response.data.pager;
                            return momentConvertFilter(response.data.items);
                        }).then(this._setUsers);
                },

                _setUsers: function(users) {
                    this.$.loaded = true;
                    this.$.users = users;
                    this.filter.toQueryString();
                }
            },
        }),
    });

    $stateProvider.state('settings.users.user', {
        url: '/:id',
        templateUrl: 'settings/userView',
        abstract: true,
        resolve: {
             user: function($stateParams, UserService) {
                return UserService.get($stateParams.id);
            },
        },
        controller: function($scope, user, UserService) {
            $scope.user = user;

            $scope.resetPassword = function() {
                return UserService.resetPassword(user.email)
            }

        },
    });

    $stateProvider.state('settings.users.user.edit', {
        templateUrl: 'settings/userEdit',
        url: '',
        resolve: {
            departments: function($stateParams, UserService) {
                return UserService.getDepartmentStaff($stateParams.id);
            },
            allDepartments: function(UserService) {
                return UserService.youthbuildDepartments();
            },
            programStaff: function($stateParams, UserService) {
                return UserService.getProgramStaff($stateParams.id, false);
            },
            coaches: function($stateParams, UserService) {
                return UserService.getProgramStaff($stateParams.id, true);
            },

        },
        controllerAs: 'ctrl',
        controller: module.cC({
            inject: ['$scope', 'departments', 'allDepartments',
                     'programStaff', 'coaches', 'coachRoles',
                     'Principal'],
            data: {
                departments: 'departments',
                allDepartments: 'allDepartments',
                programStaff: 'programStaff',
                coaches: 'coaches',
                coachRoles: 'coachRoles',
            },

            methods: {
                accessClass: function(level) {
                    if (level === 'edit') return 'fa-pencil-square-o';
                    if (level === 'view') return 'fa-eye';
                    if (level === 'admin') return 'fa-star-o';
                    return 'fa-eye-slash';
                },
                impersonate: function(id) {
                    return this.Principal.impersonate(id);
                },
            }
        }),
    });

    $stateProvider.state('settings.users.user.permissions', {
        url: '/permissions',
        templateUrl: 'settings/userPermissions',
        permission: 'viewPermissions',
        resolve: {
            permissionDef: function($http, ApiUrl) {
                return $http.get(ApiUrl('permissions'))
                    .then(function(r) { return r.data.permissions; })
            },
            userPermissions: function(user, UserService) {
                return UserService.getPermissions(user.id);
            },
        },
        controller: module.cC({
            inject: ['$scope', 'UserService', 'permissionDef', 'user',
                     'userPermissions'],
            data: {
                permissions: 'permissionDef',
                user: 'user',
                programId: '3',
                userPermissions: 'userPermissions',
                programPermissions: '{}',
            },
            watch: {
                'programId': '_refreshProgramPermissions',
            },
            methods: {
                permType: function(set, perm) {
                    return perm.model || set.model;
                },
                permName: function(set, perm) {
                    return this.permType(set, perm) === 'None' ?
                        'Global' : 'Program';
                },
                hasPerm: function(set, perm) {
                    return (this.permType(set, perm) === 'None' ?
                            this.$.userPermissions :
                            this.$.programPermissions)[perm.key];
                },
                _refreshProgramPermissions: function(id) {
                    var scope = this.$;
                    if (id) {
                        this.UserService.getPermissions(this.user.id, id)
                            .then(function(permissions) {
                                scope.programPermissions = permissions;
                            })
                    }
                }
            }
        }),
    });

});

module.directive('newUserForm', function(UserService, $state, $timeout) {
    return {
        restrict: 'E',
        templateUrl: 'settings/manageUserNameForm',
        scope: {user: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = basicForm.data = {}
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                UserService.createUser(data).then(function(user) {
                    $timeout(function() {
                        $state.go('settings.users.user.edit', {id: user.id});
                    }, 200);
                    return user;
                });
            };
        },
    };
})


module.directive('manageUserNameForm', function($http, ApiUrl) {
    return {
        restrict: 'E',
        templateUrl: 'settings/manageUserNameForm',
        scope: {user: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = basicForm.data = {
                'first_name': scope.user.first_name,
                'last_name': scope.user.last_name,
                'email': scope.user.email,
            };
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                return $http.put(ApiUrl('person', scope.user.id), data)
                    .then(function(response) {
                        angular.extend(scope.user, response.data.item);
                    });
            };
        },
    };
});


module.directive('departmentStaffForm', function(UserService, LabeledArray, ApiUrl) {
    var options = new LabeledArray([[false, "Staff"], [true, "Consultant"]]);

    return {
        restrict: 'E',
        templateUrl: 'settings/departmentStaffForm',
        scope: {staff: '=', myDepartments: '=', allDepartments: '=', user: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            var url = ApiUrl('person', scope.user.id, 'departments');
            scope.options = options;
            if (scope.staff) {
                scope.data = basicForm.data = {
                    editing: true,
                    department_id: scope.staff.department_id,
                    is_consultant: scope.staff.is_consultant,
                };
            } else {
                scope.data = basicForm.data = {
                    editing: false,
                };
                scope.$watchCollection('myDepartments', function(depts) {
                    scope.disabledDepartments = {};
                    for (var i = 0; i < depts.length; i++) {
                        scope.disabledDepartments[depts[i].department_id] = true;
                    }
                });
            }
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                var fn = data.editing ? UserService.updateDepartmentStaff :
                                        UserService.addDepartmentStaff,
                    promise = fn(scope.user.id,
                                 data.department_id,
                                 data.is_consultant);

                if (data.editing) {
                    return promise.then(function(staff) {
                        angular.copy(staff, scope.staff);
                    });
                } else {
                    return promise.then(function(staff) {
                        scope.myDepartments.push(staff);
                    });
                }
            };

            basicForm.setDeleteFunctions(function() {
                return UserService.deleteDepartmentStaff(
                        scope.user.id, scope.staff.department_id)
                    .then(function() {
                        var index = scope.myDepartments.indexOf(scope.staff);
                        if (index >= 0) {
                            scope.myDepartments.splice(index, 1);
                        }
                    });
            }, function() {
                return !!scope.staff;
            });
        },
    };
});


module.directive('programStaffForm', function(UserService, userAccessLevels) {
    return {
        restrict: 'E',
        templateUrl: 'settings/programStaffForm',
        scope: {staff: '=',  user: '=', allStaffs: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.userAccessLevels = userAccessLevels;
            linkStaffOrCoachForm(UserService, scope, basicForm, false);
        },
    };
});

module.directive('programCoachForm', function(UserService, userAccessLevels, coachRoles) {
    return {
        restrict: 'E',
        templateUrl: 'settings/programCoachForm',
        scope: {staff: '=',  user: '=', allStaffs: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.coachRoles = coachRoles;
            scope.userAccessLevels = userAccessLevels;
            linkStaffOrCoachForm(UserService, scope, basicForm, true);
        },
    }
});

function linkStaffOrCoachForm(UserService, scope, basicForm, is_coach) {
    scope.data = basicForm.data = copyStaffOrCoachData(scope.staff, is_coach);
    scope.form = basicForm.getForm();
    basicForm.save = saveStaffOrCoach(UserService, scope.user, scope.staff,
                                      scope.allStaffs, is_coach);
    basicForm.setDeleteFunctions(
        deleteStaffOrCoach(UserService, scope.user, scope.staff, scope.allStaffs),
        function() { return !!scope.staff; });
}

function copyStaffOrCoachData(staff, is_coach) {
    var data = {};
    data.editing = !!staff;
    data.program_id = staff && staff.program_id;
    data.access_level = staff && staff.access_level;

    if (is_coach) {
        data.coach_roles = (staff && angular.copy(staff.coach_roles)) || [];
    } else {
        data.is_admin = staff && staff.is_admin;
        data.is_director = staff && staff.is_director;
    }
    return data;
}

function saveStaffOrCoach(UserService, user, staff, allStaffs, is_coach) {
    return function(data) {
        data = angular.copy(data)
        data.is_coach = is_coach;
        if (data.editing) {
            return UserService.updateProgramStaff(user.id, data)
                .then(updateItem(staff));
        } else {
            return UserService.addProgramStaff(user.id, data)
                .then(allStaffs.push.bind(allStaffs));
        }
    }
}

function deleteStaffOrCoach(UserService, user, staff, allStaffs) {
    return function() {
        return UserService.deleteProgramStaff(user.id, staff.program_id)
            .then(function() {
                removeFromArray(allStaffs, staff);
            })
    };
}



function updateItem(obj) {
    return function(data) {
        angular.copy(data, obj);
    }
}

function removeFromArray(array, item) {
    console.log(arguments);
    var index = array.indexOf(item);
    if (index >= 0) {
        array.splice(index, 1);
    }
}

module.factory('coachRoles', function(LabeledArray) {
    return new LabeledArray([
        ['dol', 'DOL'],
        ['AffNet', 'AffNet'],
        ['AmC', 'AmC'],
        ['nsi', 'NSI'],
        ['pse', 'PSE'],
        ['smart', 'SMART'],
    ]);
});

module.factory('userAccessLevels', function() {
    return [
        ['restricted', 'Restricted', 'View program info and aggregate reports, but not individual student data'],
        ['view', 'View Only', 'View all reports and data, including individual student data.'],
        ['edit', 'Data Entry', 'View all reports, view and edit all student data.'],
        ['admin', 'Admin', 'View all reports, view and edit all student data, manage program users.']
    ];
});

module.filter('accessLevelName', function() {
    return function(level) {
        if (level === 'admin') return 'Admin';
        if (level === 'edit') return 'Data Entry';
        if (level === 'view') return 'View Only';
        return 'Restricted';
    };
});

module.filter('accessLevelIcon', function() {
    return function(level) {
        if (level === 'admin') return 'fa-star-o';
        if (level === 'edit') return 'fa-pencil-square-o';
        if (level === 'view') return 'fa-eye';
        return 'fa-eye-slash';
    };
});